module.exports = __webpack_public_path__ + "img/m.c765b7c7.jpg";